export default __webpack_public_path__ + "static/media/icon 8.eeace185.svg";